// Geldmodel. Puur: geen DOM, geen database, geen staat. Alles wat een bedrag,
// saldo of betaalstatus van een inschrijving bepaalt, rekent via deze functies,
// zodat een correctie nooit op de ene plek wel en op de andere niet meetelt.

export const round2 = n => Math.round((Number(n)||0) * 100) / 100;

// Sportdata owns entry_fee_eur and discount_eur. manual_adjustment_eur is
// ours: a local correction that Sportdata does not know about, positive to
// reduce what the club owes. Everything downstream (balance, status, Stripe
// amount, reminders, dashboard) reads these three helpers so a correction
// can never be applied in one place and forgotten in another.
export function billedOf(t) {
  return round2((Number(t.entry_fee_eur)||0) - (Number(t.discount_eur)||0)
                - (Number(t.manual_adjustment_eur)||0));
}
export function balanceOf(t) {
  return Math.max(0, round2(billedOf(t) - (Number(t.amount_paid_eur)||0)));
}
// A team whose outstanding amount has been settled by hand. It is no longer
// collectable, so it must drop out of reminders, Stripe and the deadline
// banner regardless of what payment_status says.
export function isWrittenOff(t) { return t?.settlement === 'written_off'; }
export function isSettled(t) {
  return isWrittenOff(t) || t?.payment_status === 'paid' || t?.payment_status === 'expired';
}

// Single source of truth for payment status. Amounts always win over
// whatever status happened to be stored earlier.
export function deriveStatus(fee, discount, paid, adjustment) {
  const adj = round2(adjustment);
  const billed = round2((Number(fee)||0) - (Number(discount)||0) - adj);
  const p = round2(paid);
  // A zero billed amount means "no fee calculated yet" when nothing was
  // corrected, but "fully written off or waived" when it was. Those must not
  // produce the same status, or every write-off lands on the flagged page.
  if (billed <= 0) return adj !== 0 ? 'paid' : 'flagged';
  if (p >= billed) return 'paid';
  if (p > 0) return 'partial';
  return 'unpaid';
}
export const deriveStatusOf = t => deriveStatus(t.entry_fee_eur, t.discount_eur,
                                         t.amount_paid_eur, t.manual_adjustment_eur);

// Inschrijving op een activiteit (stap J). Zelfde rekenregels als een team,
// maar niets te betalen is 'nvt' (gratis clinic of volledige korting) en geen
// signaal dat er een tarief ontbreekt. Gelijk aan app.inschrijving_betaalstatus.
export function inschrijvingStatus(r) {
  const adj = round2(r?.manual_adjustment_eur);
  const billed = round2((Number(r?.entry_fee_eur)||0) - (Number(r?.discount_eur)||0) - adj);
  if (billed <= 0) return adj !== 0 ? 'paid' : 'nvt';
  return deriveStatus(r.entry_fee_eur, r.discount_eur, r.amount_paid_eur, r.manual_adjustment_eur);
}
